import { defineStore } from 'pinia'

const loadStoredCluster = () => {
  try {
    const raw = window.localStorage.getItem('pinia_cluster')
    if (!raw) return { clusterInfo: null }
    const parsed = JSON.parse(raw)
    return { clusterInfo: parsed.clusterInfo || null }
  } catch (error) {
    return { clusterInfo: null }
  }
}

const persistCluster = (payload) => {
  try {
    window.localStorage.setItem('pinia_cluster', JSON.stringify(payload))
  } catch (error) {}
}

const clearStoredCluster = () => {
  try {
    window.localStorage.removeItem('pinia_cluster')
  } catch (error) {}
}

/** 클러스터 상태 관리 (Pinia 단독) */
export const useClusterStore = defineStore('cluster', {
  state: () => ({
    /** @type {{ clusterInfo: import('@/types/cluster').ClusterInfo|null }} */
    ...loadStoredCluster(),
  }),
  actions: {
    /**
     * @param {import('@/types/cluster').ClusterInfo|null} payload
     */
    setClusterInfo(payload) {
      this.clusterInfo = payload
      persistCluster({ clusterInfo: this.clusterInfo })
    },
    removeClusterInfo() {
      this.clusterInfo = null
      clearStoredCluster()
    },
  },
})

export default useClusterStore
